<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.form-instruktur-name {
  height: 44px !important;
}
</style>
<template>
  <div class="card">
    <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
      Instruktur Pelatihan
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <div class="card-body">
      <div class="card border-0 shadow p-2">
        <div class="card-body">
          <form @submit.prevent="postData">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="tipe" class="font-weight-bold">Tipe Kategori</label>
                <multiselect
                  class="mulit-select"
                  label="tipe_kategori"
                  placeholder="Pilih Tipe Kategori"
                  :show-labels="false"
                  required
                  v-model="tipeKategori"
                  :options="kategori"
                  @select="tipe_kategori"
                ></multiselect>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="" class="font-weight-bold">Pilih Kategori Anggota</label>
                  <multiselect
                    class="multi-select"
                    label="namaKategori"
                    placeholder="Pilih Kategori Anggota"
                    :show-labels="false"            
                    :options="optionKategoriAnggota"
                    v-model="kategoriAnggota"
                    :disabled="formData.tipeInstruktur == 'NON IAPI'"
                    @input="selectKategori"
                  ></multiselect>
                </div>
              </div>
              <!-- Nama Instruktur Drodown When Select IAPI -->
              <div class="form-group col-md-6 form-selected" v-if="statusKategori == false">
                <label for="tipe" class="font-weight-bold">Nama Instruktur</label>
                <multiselect
                  class="mulit-select"
                  label="nama_lengkap"
                  placeholder="Pilih Nama Instruktur"
                  :show-labels="false"
                  required
                  :disabled="disableInstruktur"
                  v-model="instruktur"
                  :options="dataUser"
                  @select="dataInstruktur"
                ></multiselect>
              </div>

              <div class="form-group col-md-6 form-selected" v-if="statusKategori == true">
                <label for="name" class="font-weight-bold">Nama Instruktur</label>
                <input
                  v-model="formData.namaInstruktur"
                  type="text"
                  class="form-control form-instruktur-name"
                  :required="formData.tipeInstruktur == 'NON IAPI'" 
                  id="name"
                  placeholder="Masukkan Nama Instruktur"
                />
              </div>

              <div class="form-group col-md-6">
                <label for="email" class="font-weight-bold">Email</label>
                <input
                  v-model="formData.email"
                  type="email"
                  class="form-control"
                  id="email"
                  placeholder="Masukkan Email"
                  :disabled="statusKategori ? false : true"
                  :required="formData.tipeInstruktur == 'NON IAPI'"

                />
              </div>

              <div class="form-group col-md-6">
                <label for="no_telp" class="font-weight-bold">No Telepon</label>
                <input
                  v-model="formData.noTelepon"
                  type="number"
                  class="form-control"
                  id="no_telp"
                  placeholder="Masukkan No. Telepon"
                  :disabled="statusKategori ? false : true"
                  :required="formData.tipeInstruktur == 'NON IAPI'"

                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="npwp" class="font-weight-bold">NPWP</label>
                <input
                  v-model="formData.npwp"
                  type="text"
                  class="form-control"
                  :required="formData.tipeInstruktur == 'NON IAPI'"
                  id="npwp"
                  placeholder="Masukkan NPWP"
                  :disabled="statusKategori ? false : true"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="instansi" class="font-weight-bold">Instansi</label>
                <input
                  v-model="formData.instansi"
                  type="text"
                  class="form-control"
                  :required="formData.tipeInstruktur == 'NON IAPI'"

                  id="instansi"
                  placeholder="Masukkan Nama Instansi"
                  :disabled="statusKategori ? false : true"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="namaBank" class="font-weight-bold">Nama Bank</label>
                <input
                  v-model="formData.namaBank"
                  type="text"
                  class="form-control"
                  oninput="this.value = this.value.toUpperCase()"
                  id="namaBank"
                  placeholder="Masukkan Nama Bank"
                  :disabled="statusKategori ? false : true"
                />
              </div>            
              <div class="form-group col-md-6">
                <label for="noRekening" class="font-weight-bold">No Rekening</label>
                <input
                  v-model="formData.nomorRekening"
                  type="text"
                  class="form-control"
                  id="noRekening"
                  placeholder="Masukkan No Rekening"
                  :disabled="statusKategori ? false : true"
                />
              </div>            
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="cv" class="font-weight-bold">
                  CV
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="customFileLangHTML"
                    @change="uploadDok($event)"
                  />
                  <label
                    class="custom-file-label"
                    for="customFileLangHTML"
                    data-browse="Unggah"
                  >{{ formData.fileName }}</label>
                </div>
                <small class="text-danger">(*File harus bertipe pdf max. 10MB)</small>
              </div>
            </div>
            <CCol sm="12 col-sm-12 px-0">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" class="custom-control-input" name="customRadio" id="aktif" v-model="formData.status" value="1" :required="formData.tipeInstruktur == 'NON IAPI'" />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" class="custom-control-input" name="customRadio" id="tidak_aktif" v-model="formData.status" value="0" :required="formData.tipeInstruktur == 'NON IAPI'" />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>
            </CCol>
            <div class="form-row col-sm-12 card-footer bg-white border-0 px-0">
                <Button class="btn btn-md btn-success px-4 py-2 ml-auto" type="submit" color="success">Simpan</Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataKeanggotaanService from "@/services/keanggotaan/data-anggota.service";
import InstrukturService from "@/services/pelatihan/instruktur.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { KategoriAnggota } from '@/mixins/master/KategoriAnggota'

export default {
  mixins: [AlertUtils, KategoriAnggota],
  data() {
    return {
      dataUser: [],
      instruktur: '',
      disableInstruktur: true,
      disableKategoriAnggota: true,
      tipeKategori: '',
      kategori: [
        {
          tipe_kategori: 'IAPI'
        },
        {
          tipe_kategori: 'NON IAPI'
        }
      ],
      formData : {
        idAnggota: '',
        tipeInstruktur: '',
        email: '',
        noTelepon: '',
        namaInstruktur: '',
        instansi: '',
        npwp: '',
        alamat: '',
        cv: '',
        status: '',
        fileName: '',
        namaBank: '',
        nomorRekening: '',
        kategoriAnggota: ''
      },
      kategoriAnggota: '',
      statusKategori: false,
      fileName: "Pilih CV"
    };
  },

  mounted() {    
    this.getData("0", "1000000", "default")
    this.getAllKategoriAnggota();
  },

  methods: {
    postData() {
      if(this.formData.tipeInstruktur == '') {
        this.alertError("Kategori Instruktur Harus Dipilih")
        return false;
      }
      this.insertData(this.formData);
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      
      var vm = this;
      InstrukturService.postInstruktur(
        formData        
      )
        .then(() => {
          loader.hide();
          vm.myModal = false;
          vm.alertSuccess();

          vm.$router.push({ path: "/pelatihan/instruktur" });
        })
        .catch(error => {
          loader.hide();
          vm.alertError(error.response.data.message);
        });
    },
    uploadDok(e) {
      var typeDok = e.target.files[0].type;
      var typeDokumen = typeDok.split("/");

      if (typeDokumen[1] != "pdf") {
        this.alertError("Dokumen Harus Bertipe PDF");
        return false;
      } else {
        this.formData.cv = e.target.files[0];
        this.formData.fileName = e.target.files[0].name;
      }
    },
    getData(currentPage, pageSize, filter) {
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;
       
      if(vm.$route.query.idInstruktur != undefined) {
        InstrukturService.getDataInstruktur(vm.$route.query.idInstruktur)
        .then(response => {
          loader.hide();
          vm.formData = response.data.singleData;
          if (this.formData.instansi == "null" || this.formData.instansi == null) {
            this.formData.instansi = "";
          }
        })
        .catch(error => {
          // comment console console.log(error);
        });
      }

      DataKeanggotaanService.getAllDataAnggota(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();

          vm.items = response.data.data;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    dataInstruktur(value) {
      this.formData.idAnggota = value.id_user;
      DataKeanggotaanService.getDataAnggota(value.id_user)
      .then(response => {
        this.formData.email = response.data.data[2].email;
        this.formData.namaInstruktur = response.data.data[2].namaLengkap;
        this.formData.noTelepon = response.data.data[1].noTelephone;
        this.formData.instansi = response.data.data[0].namaInstansi;
        this.formData.npwp = response.data.data[1].noNpwp;
        this.formData.alamat = response.data.data[1].alamatKtp;
        this.formData.namaBank = response.data.data[1].namaBank;
        this.formData.nomorRekening = response.data.data[1].nomorRekening;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },
    
    tipe_kategori(value) {
      if (value.tipe_kategori === "IAPI") {
        this.disableInstruktur = false;
        this.disableKategoriAnggota = false;
        this.statusKategori = false;
        this.formData.tipeInstruktur = value.tipe_kategori;
      } else if (value.tipe_kategori === "NON IAPI") {
        this.statusKategori = true;
        this.formData.tipeInstruktur = value.tipe_kategori;
      }
    },

    selectKategori(value){
      this.formData.kategoriAnggota = value.namaKategori
      DataKeanggotaanService.getDataAnggotaKategori(value.idKategoriAnggota)
      .then(response => {
        this.dataUser = response.data.data
      }).catch(error => { 
        // comment console console.log(error);
      });    
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>